import axiosInstance from '../axiosInstance';

export const saveCareerDraft = async (data) => {
  try {
    const response = await axiosInstance.post('/careers/draft', data, {
      headers: { 'Content-Type': 'application/json' },
    });
    return response.data.data;
  } catch (error) {
    console.error('Save Career Draft Error:', error);
    throw error;
  }
};

export const getAllCareers = async () => {
  try {
    const response = await axiosInstance.get('/careers');
    return response.data.data;
  } catch (error) {
    console.error('Get All Careers Error:', error);
    throw error;
  }
};

export const getCareer = async (careerId) => {
  try {
    const response = await axiosInstance.get(`/careers/${careerId}`);
    return response.data.data;
  } catch (error) {
    console.error('Get Career Error:', error);
    throw error;
  }
};

export const checkCareerTitleExists = async (title) => {
  try {
    const response = await axiosInstance.get('/careers/check-title', {
      params: { title },
    });
    return response.data.data;
  } catch (error) {
    console.error('Check Career Title Exists Error:', error);
    throw error;
  }
};

export const deleteCareer = async (careerId) => {
  try {
    const response = await axiosInstance.delete(`/careers/${careerId}`);
    return response.data;
  } catch (error) {
    console.error('Delete Career Error:', error);
    throw error;
  }
};

export const setStandardCareer = async (careerId) => {
  try {
    const response = await axiosInstance.patch(`/careers/${careerId}/standard`);
    return response.data;
  } catch (error) {
    console.error('Set Standard Career Error:', error);
    throw error;
  }
};

export const getStandardCareer = async () => {
  try {
    const response = await axiosInstance.get('/careers/standard');
    return response.data.data;
  } catch (error) {
    console.error('Get Standard Careers Error:', error);
    throw error;
  }
};

export const searchSkills = async (keyword) => {
  try {
    const response = await axiosInstance.get('/careers/skills/search', {
      params: { q: keyword },
      skipLoading: true,
    });
    return response.data.data ?? [];
  } catch (error) {
    console.error('Search Skills Error:', error);
    return [];
  }
};

export const translateTexts = async (texts, target = 'ko') => {
  if (!Array.isArray(texts) || texts.length === 0) return [];
  try {
    const response = await axiosInstance.post(
      '/careers/translate',
      { texts, target },
      { skipLoading: true }
    );
    return response.data.data ?? texts;
  } catch (error) {
    console.error('Translate Error:', error);
    return texts;
  }
};
